import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { modal } from 'react-redux-modal';

import {
  PopoutVideoManager,
  PopoutCommentsManager,
  FeedbackModal,
} from '../../../components';

import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

class PopModal extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.renderCopy = this.renderCopy.bind(this);
    this.onFeedback = this.onFeedback.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      setCookie: null,
    };
  }

  componentDidMount() {
    modalViewGA('popModal');
  }

  onFeedback(e) {
    e.preventDefault();
    modal.clear();
    modal.add(FeedbackModal, { size: 'medium', hideTitleBar: true });
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
  }

  handleInputChange(e) {
    this.setState({
      setCookie: e.target.checked,
    });
  }

  renderCopy(type) {
    if (type === 'livecam') {
      return (
        <div>
          <p>Have you ever wanted to watch more than one livecam at a time?  Press Pop Livecam and the cam pops out to the side of the screen. You can move it around and even arrange its size.</p>
          <p>In fact, you can watch as many live cams as you want! Just choose the live cam and when it plays, press the pop livecam icon!</p>
        </div>
      );
    } else if (type === 'comments') {
      return (
        <div>
          <p>Press Pop Comments and the comment section can be moved to any part of your screen.</p>
          <p>You can enlarge, reduce and rearrange your comments so watching your beloved livecam and commenting can be be done side by side!</p>
          <p>We value all feedback to help add to your experience.</p>
        </div>
      );
    }

    return '';
  }

  render() {
    const { currentItem, type } = this.props;
    const popButton = type === 'livecam'
      ? (<PopoutVideoManager ref="popoutManager" group={currentItem.camgroup_slug} slug={currentItem.slug} setCookie={this.state.setCookie} />)
      : (<PopoutCommentsManager group={currentItem.camgroup_slug} slug={currentItem.slug} setCookie={this.state.setCookie} newCommentSystem={currentItem.newCommentSystem} />);

    return (
      <div className="modals-popup pop-modal u-font-foundation-roman">
        <div className="modal-header d-flex align-items-center">
          <div className="col">explore.org - never stop learning</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.closeModal} />
          </div>
        </div>
        <div className="info">
          <div className="mb-10">
            <div className="d-flex justify-content-center mb-20">
              <div className="form-check dont-show">
                <input
                  type="checkbox"
                  id="do-not-show"
                  onChange={this.handleInputChange}
                />
                <label className="form-check-label" htmlFor="exampleCheck1">Don&apos;t show this again</label>
              </div>
              {popButton}
            </div>
            <div>
              {this.renderCopy(type)}
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="video-player-btn text-btn inverse-btn text-uppercase"
                onClick={e => this.onFeedback(e)}
              >
                <div>feedback</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

PopModal.propTypes = {
  currentItem: PropTypes.shape({}).isRequired,
  type: PropTypes.string.isRequired,
  removeModal: PropTypes.func,
};

PopModal.defaultProps = {
  removeModal: () => {},
};

PopModal.contextTypes = {
  router: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    currentItem: state.currentItem.data,
  };
};

export default connect(mapStateToProps)(PopModal);
